import React from 'react';

function StatCard({ label, value, sublabel, accent }) {
  const accentColors = {
    blue: 'border-blue-500 bg-blue-50',
    green: 'border-green-500 bg-green-50',
    amber: 'border-amber-500 bg-amber-50',
    slate: 'border-slate-400 bg-slate-50',
  };

  return (
    <div className={`bg-white rounded-lg shadow-sm border-l-4 p-4 ${accentColors[accent] || accentColors.slate}`}>
      <div className="text-sm font-medium text-slate-500">{label}</div>
      <div className="text-2xl font-bold text-slate-800 mt-1">{value}</div>
      {sublabel && <div className="text-xs text-slate-500 mt-1">{sublabel}</div>}
    </div>
  );
}

export default function SummaryBar({ audit }) {
  const { total_assets, type_counts, file_sizes } = audit;

  const topTypes = Object.entries(type_counts.by_category || {})
    .sort((a, b) => b[1] - a[1])
    .slice(0, 3)
    .map(([type, count]) => `${count} ${type}`)
    .join(', ');

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      <StatCard
        label="Total Assets"
        value={total_assets.toLocaleString()}
        sublabel={`${Object.keys(type_counts.by_extension || {}).length} file types detected`}
        accent="blue"
      />
      <StatCard
        label="Total File Size"
        value={file_sizes.file_size_available ? file_sizes.total_formatted : 'Not available'}
        sublabel={file_sizes.file_size_available ? null : 'No file size column in this export'}
        accent={file_sizes.file_size_available ? 'green' : 'slate'}
      />
      <StatCard
        label="Top Asset Types"
        value={topTypes || 'None detected'}
        accent="amber"
      />
      <StatCard
        label="Source Columns"
        value={audit.columns.length}
        sublabel={`${audit.columns.length} fields from this export`}
        accent="slate"
      />
    </div>
  );
}
